// @Utility
import readMenuIcon from "@utility/app/readMenuIcon";

// Component
import { Grid } from "@mui/material";
import Withdraw from "./Withdraw";

export default function Content({ dataCms, withdrawRank }) {

    const renderWithdrawRank = () => {
        if (withdrawRank === null) return null;

        return (
            <Withdraw
                withdrawRank={withdrawRank}
                pageName="รายงานผลอันดับการถอนเงิน"
            />
        );
    };

    const renderContent = () => {
        if (withdrawRank !== null) {
            return (
                <Grid container>
                    <Grid item xs={false} md={3}></Grid>
                    <Grid item xs={12} md={6}>
                        {
                            renderWithdrawRank()
                        }
                    </Grid>
                    <Grid item xs={false} md={3}></Grid>
                </Grid>
            );
        }
    };

    return (
        <div id="rank" className={`rankContent ${readMenuIcon(dataCms?.image_rank_bg, "") === "" ? "" : "rankContentImg"}`} style={{ backgroundImage: readMenuIcon(dataCms?.image_rank_bg, "") === "" ? "" : `url("${dataCms?.image_rank_bg}")` }}>
            {
                renderContent()
            }

            <br /><br />
        </div>
    );
}